import { useEffect, useState } from 'react';
import { Container, LinearProgress, Tab, Tabs, Chip } from '@mui/material';
import { Button, AppBar, Toolbar, Menu, MenuItem } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useSession } from './SessionContext';
import { useNotification } from './NotificationContext';
import { sendApiRequest } from '../lib/api/public';
import notify from '../lib/notify';

const LoggedInWrapper = ({ children, user }) => {
  const router = useRouter();
  const currentUrl = router.asPath;
  const [anchorEl, setAnchorEl] = useState(null);
  const { unreadApplicantsCount } = useNotification();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  let activeTab = -1;

  if (currentUrl.includes('jobs') || window.location.pathname == '/') {
    activeTab = 0;
  }

  if (currentUrl.includes('candidates')) {
    activeTab = 1;
  }

  if (currentUrl.includes('settings')) {
    activeTab = 2;
  }

  const promoteCompany = () => {
    sendApiRequest({
      path: `/companies/promote`,
    }).then((response) => {
      window.open(response.paymentUrl);
    }).catch((e) => {
      notify(e.message);
    })
  }

  let candidatesNotification = null

  if (unreadApplicantsCount && unreadApplicantsCount > 0) {
    candidatesNotification = <Chip label={unreadApplicantsCount} color="primary" size="small" sx={{ marginLeft: '-10px' }} />
  }

  return (
    <>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: '#000' }}>
        <Toolbar style={{ justifyContent: 'space-between' }}>
          <Tabs value={activeTab} sx={{ marginLeft: '-30px' }}>
            <Link href="/jobs">
              <Tab label="Jobs" />
            </Link>

            <Link href="/candidates">
              <Tab label="Candidates" />
              {candidatesNotification}
            </Link>
          </Tabs>

          <div>
            <Button variant="contained" color="success" onClick={promoteCompany}>
              Promote your company
            </Button>

            <span style={{ color: '#1976d2' }}>{' | '}</span>

            <span>{user && user.companyName}</span>

            <Button
              aria-controls="menu"
              aria-haspopup="true"
              onClick={handleMenuClick}
              className='go-to-profile'
            >
              {user ?user.email[0] : ''}
            </Button>

            <div style={{ marginLeft: 8 }}>
            </div>

            <Menu
              id="menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem>
                <Link href="/logout">Logout</Link>
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      <main style={{ flexGrow: 1, padding: '24px' }}>
        {children}
      </main>
    </>
  );
};

type Props = {
  children: any;
  title: string;
  sideBar?: any;
  isLoading?: any;
}

const AuthLayout = ({ sideBar, children, title, isLoading }: Props) => {
  const { user, loadingUser } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (!loadingUser) {
      if (!user) {
        router.push('/login');
      }

      if (window.location.pathname === '/') {
        router.push('/jobs');
      }
    }
  }, [user, router, loadingUser]);

  if (!user) return <div>Loading...</div>;

  return (
    <LoggedInWrapper user={user}>

      { sideBar ? sideBar : null }

      <Container sx={{ marginTop: '70px', marginLeft: '270px !important' }} maxWidth="lg">
        <h2>{title}</h2>

        {isLoading ? <><LinearProgress /> <br /> </> : null}

        {children}
      </Container>
    </LoggedInWrapper>
  );
};

export default AuthLayout;